module.exports = __webpack_public_path__ + "static/media/vision.5dd3b135.png";